exports.components = {
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-pages-simple-index-tsx": () => import("./../../../src/pages/simple/index.tsx" /* webpackChunkName: "component---src-pages-simple-index-tsx" */),
  "component---src-templates-markdown-page-tsx": () => import("./../../../src/templates/markdown-page.tsx" /* webpackChunkName: "component---src-templates-markdown-page-tsx" */)
}

